var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsappIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.426207 10.3752C0.4257 12.1396 0.868216 13.8625 1.7096 15.3809L0.345703 20.5693L5.44193 19.1771C6.84593 19.9744 8.42683 20.3952 10.0357 20.3956H10.0399C15.338 20.3956 19.6507 15.9039 19.653 10.3831C19.654 7.70785 18.6549 5.19228 16.8398 3.29969C15.025 1.40721 12.6113 0.364442 10.0395 0.363281C4.74089 0.363281 0.428434 4.85467 0.426207 10.3752Z",
    fill: "url(#paint0_linear_1148_21104)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0836426 10.3711C0.083035 12.199 0.541449 13.9834 1.41281 15.5562L0 20.9306L5.279 19.4885C6.73353 20.3148 8.37115 20.7504 10.0376 20.751H10.0419C15.53 20.751 19.9977 16.0978 20 10.3794C20.0009 7.608 18.9659 5.00202 17.086 3.0416C15.2057 1.08139 12.7057 0.00116051 10.0419 0C4.55275 0 0.0858704 4.65249 0.0836426 10.3711ZM3.22733 15.2854L3.03027 14.9594C2.20164 13.5868 1.76429 12.0005 1.7649 10.3717C1.76672 5.61867 5.4795 1.75174 10.045 1.75174C12.2559 1.75269 14.3338 2.65061 15.8966 4.27986C17.4593 5.90922 18.3192 8.07516 18.3186 10.3788C18.3166 15.1319 14.6037 18.9994 10.0419 18.9994H10.0386C8.55322 18.9985 7.09646 18.583 5.82592 17.7976L5.52355 17.6108L2.3909 18.4665L3.22733 15.2854Z",
    fill: "url(#paint1_linear_1148_21104)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.55357 6.03601C7.36715 5.6043 7.171 5.59565 6.99369 5.58806C6.84858 5.58162 6.68261 5.58204 6.51685 5.58204C6.35088 5.58204 6.08132 5.64703 5.85338 5.90635C5.62523 6.16578 4.98242 6.79288 4.98242 8.06828C4.98242 9.34379 5.87414 10.5763 5.99839 10.7494C6.12284 10.9222 7.71974 13.6232 10.2488 14.6623C12.3507 15.5258 12.7784 15.3541 13.2346 15.3108C13.6908 15.2677 14.7067 14.6839 14.914 14.0786C15.1214 13.4733 15.1214 12.9545 15.0592 12.8461C14.9971 12.7381 14.8311 12.6732 14.5823 12.5436C14.3334 12.414 13.1101 11.7868 12.8821 11.7003C12.6539 11.6139 12.4881 11.5707 12.3221 11.8302C12.1562 12.0895 11.6797 12.6732 11.5345 12.8461C11.3894 13.0193 11.2442 13.041 10.9954 12.9113C10.7465 12.7812 9.94508 12.5078 8.99443 11.6247C8.25471 10.9376 7.75539 10.089 7.61018 9.82952C7.46507 9.5703 7.59468 9.42988 7.71944 9.30064C7.83123 9.18448 7.96834 8.99796 8.09279 8.84667C8.21694 8.69527 8.25836 8.58724 8.34129 8.41433C8.42433 8.2413 8.38281 8.08991 8.32063 7.96025C8.25836 7.83059 7.77483 6.54864 7.55357 6.03601Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1148_21104",
    x1: 965.709,
    y1: 2020.97,
    x2: 965.709,
    y2: 0.364245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FAF38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1148_21104",
    x1: 1000,
    y1: 2093.06,
    x2: 1000,
    y2: -0.00274464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappIcon);
export default __webpack_public_path__ + "static/media/whatsapp-icon.1d6f2837408b4458a941ad5568697e3b.svg";
export { ForwardRef as ReactComponent };